import { Link } from "react-router-dom"

import folderBack from "../../../../assets/img/folder-back.svg"
import folderContent from "../../../../assets/img/folder-content.svg"
import folderFront from "../../../../assets/img/folder-front.svg"
import folderFrontBlue from "../../../../assets/img/folder-front-blue.svg"
import folderFrontGreen from "../../../../assets/img/folder-front-green.svg"
import folderIcon1 from "../../../../assets/img/folder_icon1.svg"
import folderIcon2 from "../../../../assets/img/folder_icon2.svg"
import folderIcon3 from "../../../../assets/img/folder_icon3.svg"
import folderIcon4 from "../../../../assets/img/folder_icon4_1.svg"
import folderIcon5 from "../../../../assets/img/folder_icon5.svg"
import folderIcon6 from "../../../../assets/img/folder_icon6.svg"

type IconType = "keys" | "megaphone" | "building" | "mida" | "plant" | "chart"
type ThemeKey = "light" | "blue" | "green"

const FRONT_BY_THEME: Record<ThemeKey, string> = {
	light: folderFront,
	blue: folderFrontBlue,
	green: folderFrontGreen,
}

// Icons map to folders by order (1st folder → folder_icon1, etc.)
const FOLDER_ICONS: string[] = [folderIcon1, folderIcon2, folderIcon3, folderIcon4, folderIcon5, folderIcon6]

type FolderCardItem = {
	title: string
	titleFontSize?: string
	button: string
	icon: IconType
	theme: ThemeKey
	badge?: boolean
	badgeText?: string
	smallLabel?: boolean
	smallIcon?: boolean
	to?: string
	href?: string
	newTab?: boolean
}

const CardShell = ({ item, icon }: { item: FolderCardItem; icon?: string }) => (
	<div className={`folder-card folder-card--${item.theme}`}>
		<img src={folderBack} alt="" className="folder-card__back" />
		<div className="folder-card__paper">
			{item.badge && <span className="folder-card__badge">{item.badgeText || "Yenilənib"}</span>}
			<div className="folder-card__title my-md-2" style={{fontSize: item.titleFontSize}}>{item.title}</div>
			<img src={folderContent} alt="" className="folder-card__content" />
		</div>
		<img src={FRONT_BY_THEME[item.theme]} alt={item.button} className="folder-card__front" />
		{icon && <img src={icon} alt="" className={`folder-card__icon${item.smallIcon ? " folder-card__icon--sm" : ""}`} />}
		<div className={`folder-card__label${item.smallLabel ? " folder-card__label--sm" : ""}`}>{item.button}</div>
	</div>
)

const FolderCards = ({ items }: { items: FolderCardItem[] }) => (
	<div className="folder-cards">
		{items.map((item, i) =>
			item.href ? (
				<a
					key={i}
					href={item.href}
					target={item.newTab ? "_blank" : undefined}
					rel={item.newTab ? "noreferrer" : undefined}
					className="folder-cards__link"
				>
					<CardShell item={item} icon={FOLDER_ICONS[i]} />
				</a>
			) : (
				<Link
					key={i}
					to={item.to || "/"}
					target={item.newTab ? "_blank" : undefined}
					rel={item.newTab ? "noreferrer" : undefined}
					className="folder-cards__link"
				>
					<CardShell item={item} icon={FOLDER_ICONS[i]} />
				</Link>
			)
		)}
	</div>
)

export default FolderCards
export type { FolderCardItem }
